var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",class:_vm.bgColor},[_c('div',{staticClass:"svgwrapper"},[_c(_vm.icon || 'BetterCare',{tag:"component"})],1),_c('div',{staticClass:"diamond"})])}
var staticRenderFns = []

export { render, staticRenderFns }